import BloomsTaxonomyActivityView from "@features/tools/view/blooms-taxonomy-activity-view";

const BloomsTaxonomyActivity = () => {
  return <BloomsTaxonomyActivityView />;
};

export default BloomsTaxonomyActivity;
